import * as orderService from '../services/order'

export const ACTIONS = {
  POST_PRODUCT_TO_RETURN_REQUEST: 'POST_PRODUCT_TO_RETURN_REQUEST',
  POST_PRODUCT_TO_RETURN_SUCCESS: 'POST_PRODUCT_TO_RETURN_SUCCESS',
  POST_PRODUCT_TO_RETURN_FAILURE: 'POST_PRODUCT_TO_RETURN_FAILURE',
  SAVE_PRODUCT_TO_RETURN_SUCCESS: 'SAVE_PRODUCT_TO_RETURN_SUCCESS',
  GET_ORDER_INVOICE_REQUEST: 'GET_ORDER_INVOICE_REQUEST',
  GET_ORDER_INVOICE_SUCCESS: 'GET_ORDER_INVOICE_SUCCESS',
  GET_ORDER_INVOICE_FAILURE: 'GET_ORDER_INVOICE_FAILURE',
  GET_PRODUCT_RETURNING_REASONS_REQUEST:
    'GET_PRODUCT_RETURNING_REASONS_REQUEST',
  GET_PRODUCT_RETURNING_REASONS_SUCCESS:
    'GET_PRODUCT_RETURNING_REASONS_SUCCESS',
  GET_PRODUCT_RETURNING_REASONS_FAILURE:
    'GET_PRODUCT_RETURNING_REASONS_FAILURE',
}

export const POST_PRODUCT_TO_RETURN_REQUEST = () => ({
  type: ACTIONS.POST_PRODUCT_TO_RETURN_REQUEST,
})

export const POST_PRODUCT_TO_RETURN_SUCCESS = (response) => ({
  type: ACTIONS.POST_PRODUCT_TO_RETURN_SUCCESS,
  response,
})

export const POST_PRODUCT_TO_RETURN_FAILURE = (err) => ({
  type: ACTIONS.POST_PRODUCT_TO_RETURN_FAILURE,
  err,
})

export function postProductToReturn(data) {
  return (dispatch) => {
    dispatch(POST_PRODUCT_TO_RETURN_REQUEST())

    return orderService.postProductToReturn(data).then(
      (response) => dispatch(POST_PRODUCT_TO_RETURN_SUCCESS(response)),
      (err) => dispatch(POST_PRODUCT_TO_RETURN_FAILURE(err))
    )
  }
}

export const SAVE_PRODUCT_TO_RETURN_SUCCESS = (response) => ({
  type: ACTIONS.SAVE_PRODUCT_TO_RETURN_SUCCESS,
  response,
})

export function saveProductToReturn(data) {
  return (dispatch) => {
    dispatch(SAVE_PRODUCT_TO_RETURN_SUCCESS(data))
  }
}

export const GET_ORDER_INVOICE_REQUEST = () => ({
  type: ACTIONS.GET_ORDER_INVOICE_REQUEST,
})

export const GET_ORDER_INVOICE_SUCCESS = (invoice) => ({
  type: ACTIONS.GET_ORDER_INVOICE_SUCCESS,
  invoice,
})

export const GET_ORDER_INVOICE_FAILURE = (err) => ({
  type: ACTIONS.GET_ORDER_INVOICE_FAILURE,
  err,
})

export function getOrderInvoice(orderToken: number) {
  return (dispatch) => {
    dispatch(GET_ORDER_INVOICE_REQUEST())
    return orderService.getOrderInvoice(orderToken).then(
      (response) => dispatch(GET_ORDER_INVOICE_SUCCESS(response)),
      (err) => dispatch(GET_ORDER_INVOICE_FAILURE(err))
    )
  }
}

export const GET_PRODUCT_RETURNING_REASONS_REQUEST = () => ({
  type: ACTIONS.GET_PRODUCT_RETURNING_REASONS_REQUEST,
})

export const GET_PRODUCT_RETURNING_REASONS_SUCCESS = (response) => ({
  type: ACTIONS.GET_PRODUCT_RETURNING_REASONS_SUCCESS,
  response,
})

export const GET_PRODUCT_RETURNING_REASONS_FAILURE = (err) => ({
  type: ACTIONS.GET_PRODUCT_RETURNING_REASONS_FAILURE,
  err,
})

export function getProductReturningReasons(locale: string) {
  return (dispatch) => {
    dispatch(GET_PRODUCT_RETURNING_REASONS_REQUEST())

    return orderService.getProductReturningReasons(locale).then(
      (response) => dispatch(GET_PRODUCT_RETURNING_REASONS_SUCCESS(response)),
      (err) => dispatch(GET_PRODUCT_RETURNING_REASONS_FAILURE(err))
    )
  }
}
